import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/js/all.min'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/custom.css'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue, IconsPlugin)

import Notifications from 'vue-notification'
Vue.use(Notifications);

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard);

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate, { locale: 'ca'});

import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
import language_ca from './assets/locale/ca.js';
import language_es from './assets/locale/es.js';
import language_en from './assets/locale/en.js';
const i18n = new VueI18n({
  locale: 'ca', // set locale
  messages: {
    ca: language_ca,
    es: language_es,
    en: language_en
  },
});

import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

import LangFlag from 'vue-lang-code-flags';
Vue.component('lang-flag', LangFlag);

import VueHtmlToPaper from "vue-html-to-paper";
const optionsHtmlToPAper = {
  name: "_self",
  autoClose: false,
  "windowTitle": "Impressió resguard enquesta",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=no"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"
  ]
};
Vue.use(VueHtmlToPaper, optionsHtmlToPAper);

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
